import { useEffect, useState } from 'react';

function useScroll({ enabled = true } = { enabled: true }) {
  // eslint-disable-next-line no-undef
  const [scrollY, setScrollY] = useState(window.scrollY);

  const handleNavigation = (event) => {
    setScrollY(event.currentTarget.scrollY);
  };

  useEffect(() => {
    if (enabled) {
      // eslint-disable-next-line no-undef
      window.addEventListener('scroll', handleNavigation);
    }

    return () => {
      // eslint-disable-next-line no-undef
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [enabled]);

  return { scrollY };
}

export { useScroll };
